import React from 'react';
import SubPage from '#/common/components/SubPage';
import { Tab } from '#/common/components/SubPage/SubPageProps';
import If from '#/common/components/If';
import { Navigate } from 'react-router-dom';
import Tenants from '../tenants/components/Tenants';
import Users from '../users/components/Users';
import DataImportPage from '../dataImport/pages/DataImportPage';
import { UserRole } from '#/common/types/userTypes';
import useSession from '#/common/hooks/useSession';
import { rolesWithAccessToAdminMenu } from '#/app/components/AppMenu/menuItems';
import ModelLibrary from '../modelLibrary/components/ModelLibrary';
import SyncHistory from '../syncHistory/components/SyncHistoryDataGrid';

export type AdminTab = 'tenants' | 'users' | 'model-library' | 'data-import' | 'sync-history';

export const defaultTab: AdminTab = 'tenants';

export interface AdminProps {
  readonly tab?: AdminTab;
}

const tabs: Tab<AdminTab>[] = [
  {
    key: 'tenants',
    text: 'Organizations',
  },
  {
    key: 'users',
    text: 'Users',
  },
  {
    key: 'model-library',
    text: 'Model Library',
  },
  {
    key: 'data-import',
    text: 'Data Import',
  },
  {
    key: 'sync-history',
    text: 'Sync History',
  },
];

const rolesWithAccessToPage: UserRole[] = rolesWithAccessToAdminMenu;

const AdminPage: React.FC<AdminProps> = ({ tab }) => {
  const { user } = useSession();
  const role = user?.role as UserRole | undefined;

  const selectedTab = tabs.find((t) => t.key === tab);
  const title = selectedTab?.text;

  //   const { assets, types, manufacturers, models, locations } = useAssetsPropsCounts();

  const adminTabs = tabs;
  //   const assetsTabs = useMemo(
  //     () =>
  //       tabs.map((t) => {
  //         if (t.key === 'list') return { ...t, count: assets };
  //         if (t.key === 'types') return { ...t, count: types };
  //         if (t.key === 'manufacturers') return { ...t, count: manufacturers };
  //         if (t.key === 'models') return { ...t, count: models };
  //         if (t.key === 'locations') return { ...t, count: locations };
  //         return t;
  //       }),
  //     [assets, types, manufacturers, models, locations],
  //   ) as Tab[];

  if (!role) return null;

  if (!rolesWithAccessToPage.includes(role)) {
    const redirectTo = '/';
    return <Navigate to={redirectTo} replace />;
  }

  const invalidTab = tabs.every((t) => t.key !== tab);
  if (invalidTab) {
    const redirectTo = `../${defaultTab}`;
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <SubPage title={title} tabs={adminTabs} selectedTab={tab}>
      <If condition={tab === 'tenants'}>
        <Tenants />
      </If>
      <If condition={tab === 'users'}>
        <Users />
      </If>
      <If condition={tab === 'model-library'}>
        <ModelLibrary />
      </If>
      <If condition={tab === 'data-import'}>
        <DataImportPage />
      </If>
      <If condition={tab === 'sync-history'}>
        <SyncHistory />
      </If>
    </SubPage>
  );
};

export default React.memo(AdminPage);
